module.exports = __webpack_public_path__ + "img/flounce_width.f199eb1a.png";